import React from 'react';
import ContactUs from '../components/ContactUs';
import PageSeo from '../components/shared/PageSeo';
import { PAGE_SEO } from '../data/seo';

const ContactPage = () => (
  <>
    <PageSeo {...PAGE_SEO.contact} />
    <ContactUs />
  </>
);

export default ContactPage;
